<template>
    <div class="placeholder" :class="{animated: animation_duration}" :style="animation_css"/>
</template>

<script>
export default {
    name: "Placeholder",
    props: {
        animation: {
            type: [Number, String, Boolean],
            default: '1.5s',
        }
    },

    computed: {

        animation_duration(){
            let duration = null;
            if( this.animation ){
                if( this.animation === true ){
                    duration = '1.5s';
                }else if( this.animation === 'off' ){
                    duration = null;
                }else{
                    duration = this.animation;
                }
            }
            return duration;
        },

        animation_css(){
            return this.animation_duration ? {animationDuration: this.animation_duration} : null;
        }
    }

}
</script>

<style lang="scss" scoped>
.placeholder{
    background: rgba($gray-500, .5);
    min-height: 3px;
    height: 1em;
    position: relative;
    overflow: hidden;

    &.animated{
        &:before{
            content: '';
            width: 40px;
            background: rgb(255,255,255);
            background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 29%, rgba(255,255,255,.5) 50%, rgba(255,255,255,1) 100%);
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            transform: translateX(-50%);
            animation: slide infinite 1.5s;
            opacity: .5;
        }
    }
}

@keyframes slide {
    from{
        left: 0;
    }
    to{
        left: 100%;
    }
}

</style>
